module.exports = __webpack_public_path__ + "img/trends_13.4b54557a.jpg";